export const CloseCircle = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.62195 9.62195L22.3779 22.3779" stroke="currentColor" stroke-width="2"/>
<path d="M22.378 9.62195L9.62196 22.3779" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
</svg>`;
